/**
 * Typed access to the calendar metrics copy — the day-header numbers' locked
 * triple (JSON + this loader + calendarMetrics.test.ts), modelled on
 * metrics/metricsGlossary.ts but deliberately separate from it: the glossary
 * is scoped to habit metrics by its own `_about` and test chain, and the
 * docs/43 ruling is that a non-habit ⓘ number mints a new triple rather than
 * widening the glossary (the queueCadence precedent).
 */
import copy from './calendarMetrics.json';

export interface CalendarMetricFacts {
  [fact: string]: boolean;
}

export interface CalendarMetricEntry {
  label: string;
  what: string;
  formula: string;
  window: string;
  denominator: string;
  includes_open_period: boolean;
  facts?: CalendarMetricFacts;
}

export type CalendarMetricKey = keyof typeof copy.metrics;

const METRICS = copy.metrics as unknown as Record<string, CalendarMetricEntry>;

export const CALENDAR_METRIC_KEYS = Object.keys(METRICS) as CalendarMetricKey[];

/**
 * The entry for a key, or null for an unknown key so a missing entry degrades
 * to "no popover" rather than a crash (the getMetricInfo convention).
 */
export const getCalendarMetricInfo = (
  key: string,
): CalendarMetricEntry | null => METRICS[key] ?? null;

export default METRICS;
